<script>
import PublishElementTitle from "../../publish-element-title.vue";
import {elementSizeDifferentFromLayerSize} from "../../../../../../utils/publish";

export default {
    name: "calendar-element-type",
    components: {PublishElementTitle},
    props: {
        /** @type CalendarPublishElement */
        element: {}
    },
    computed: {
        sizeNotMatching() {
            if (!this.element || !this.element.data) {
                return false;
            }

            const {data, layer} = this.element;

            return elementSizeDifferentFromLayerSize(data.width, data.height, layer.width, layer.height);
        },
    }
}
</script>

<template>
    <publish-element-title
        :sizeNotMatching="sizeNotMatching"
        :data="element.data"
        :layer="element.layer"
    />
</template>
